module.exports = __webpack_public_path__ + "img/banner-img4x.19a75560.png";